<!-- 温控器参数详情 -->
<template>
  <div class="meter-detail-box">
    <cmp-drawer :show="show" :title="title" @onClose="handleClose" @submit="hanleSubmit">
        <div>
            <p class="meter-title">基本信息</p>
            <el-row :gutter="5">
                <el-col :span="10"><span>业主名称：</span><span>{{modelData.householdname}}</span></el-col>
                <el-col :span="4"><span>房间号：</span><span>{{modelData.housename}}</span></el-col>
                <el-col :span="6"><span>表计序列号：</span><span>{{modelData.deviceSerial}}</span></el-col>
                <el-col :span="4"><span>在线状态：</span><span>{{fmtOnlineStatus(modelData.status)}}</span></el-col>
            </el-row>
            <p class="meter-title">温控器运行状态</p>
            <el-row :gutter="5">
                <el-col :span="6"><span>运行状态：</span><span>{{modelData.linkStatus}}</span></el-col>
                <el-col :span="6"><span>故障状态：</span><span>{{modelData.sysStatusResult}}</span></el-col>
                <el-col :span="6"><span>供冷/供热：</span><span>{{modelData.mode_status}}</span></el-col>
                <el-col :span="6"><span>余额状态：</span><span>{{modelData.balanceAlarm}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="6"><span>使用状态：</span><span>{{modelData.disabled}}</span></el-col>
                <el-col :span="6"><span>计费状态：</span><span>{{modelData.allowCharging}}</span></el-col>
                <el-col :span="6"><span>模式：</span><span>{{modelData.factoryMode}}</span></el-col>
                <el-col :span="6"><span>累计读数：</span><span>{{modelData.fcuCounter}}</span></el-col>
            </el-row>
            <p class="meter-title">风盘运行状态</p>
            <el-row :gutter="5">
                <el-col :span="6"><span>地暖阀：</span><span>{{modelData.hasFloorHeating}}</span></el-col>
                <el-col :span="6"><span>水阀状态：</span><span>{{modelData.valve1On + '' + modelData.valve2On}}</span></el-col>
                <el-col :span="6"><span>风速：</span><span>{{`${modelData.fcuHighSpeed}${modelData.fcuLowSpeed}${modelData.fcuMediumSpeed}`}}</span></el-col>
                <el-col :span="6"><span>计量状态：</span><span>{{modelData.fcuInCounting}}</span></el-col>
            </el-row>
            <el-row>
                <el-col :span="24"><span>故障情况：</span><span>{{faultMsgStr}}</span></el-col>
            </el-row>
            <p class="meter-title">其他信息</p>
            <el-row :gutter="5">
                <el-col :span="6"><span>当月费用：</span><span>{{baseData.monthly_fee_int + '元'}}</span></el-col>
                <el-col :span="6"><span>当前余额：</span><span>{{baseData.current_balance_int+ '元'}}</span></el-col>
                <el-col :span="6"><span>查询设定：</span><span>{{fmtStr_0_1(baseData.allow_query, '不可查询','可查询')}}</span></el-col>
                <el-col :span="6"><span>通讯中断判定时间：</span><span>{{baseData.link_down_threshold + 'min'}}</span></el-col>
            </el-row>
            <!-- 风机盘管 -->
            <p class="meter-title">风盘信息</p>
            <el-row :gutter="5">
                <el-col :span="6"><span>电机功率：</span><span>{{baseData.fcu_motor_power + 'W'}}</span></el-col>
                <el-col :span="6"><span>高档制冷量：</span><span>{{baseData.high_capacity + 'W'}}</span></el-col>
                <el-col :span="6"><span>中档制冷量：</span><span>{{baseData.medium_capacity + 'W'}}</span></el-col>
                <el-col :span="6"><span>低档制冷量：</span><span>{{baseData.low_capacity + 'W'}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="6"><span>地暖盘管换热量：</span><span>{{baseData.floor_heating_capacity + 'W'}}</span></el-col>
            </el-row>
            <!-- 温控器面板参数 -->
            <p class="meter-title">温控器参数</p>
            <el-row :gutter="5">
                <el-col :span="6"><span>开关机：</span><span>{{funFmtWKQParmas(baseData.power_on).powerOn()}}</span></el-col>
                <el-col :span="6"><span>模式：</span><span>{{funFmtWKQParmas(baseData.setting_mode).settingMode()}}</span></el-col>
                <el-col :span="6"><span>风速：</span><span>{{funFmtWKQParmas(baseData.setting_speed).settingSpeed()}}</span></el-col>
                <el-col :span="6"><span>温度：</span><span>{{baseData.setting_temperature/10 + '℃'}}</span></el-col>
            </el-row>
            <el-row :gutter="5">
                <el-col :span="6"><span>键盘锁定：</span><span>{{funFmtWKQParmas(baseData.setting_key_lock).setting_key_lock()}}</span></el-col>
                <el-col :span="6"><span>来电启动：</span><span>{{funFmtWKQParmas(baseData.setting_op_at_acback).setting_op_at_acback()}}</span></el-col>
                <el-col :span="6"><span>风扇模式使能：</span><span>{{funFmtWKQParmas(baseData.setting_enable_fanonly).setting_enable_fanonly()}}</span></el-col>
                <el-col :span="6"><span>温度设置：</span><span>{{`上限${baseData.setting_temperature_ul}/下限${baseData.setting_temperature_dl}`}}</span></el-col>
            </el-row>
        </div>
    </cmp-drawer>
  </div>
</template>

<script>
import CmpDrawer from '@/components/CmpDrawer/CmpDrawer'
import { funFmtWKQParmas, funFmtOnlineStatus } from '@/utils/utils'
export default {
    name: "CmpWkqDetail",
    props: ["show", "modelData"],
    data() {
        return {
        };
    },
    computed: {
        title() {
            return `${this.modelData.deviceType}：${this.modelData.deviceModel}`;
        },
        baseData() {
            return this.modelData._data || {}
        },
        faultMsgStr() {
            if(!this.modelData.faultMsg) return this.modelData.sysStatusResult
            return this.modelData.faultMsg.join('、')
        },
    },
    components: {
        CmpDrawer
    },
    created() {
        // console.log(this.modelData)
    },
    methods: {
        funFmtWKQParmas,
        // 关闭添加设备
        handleClose(bool) {
            this.$emit("update:show", false);
        },
        // 确认添加设备
        hanleSubmit(data) {
            this.$emit("update:show", false);
        },
        fmtStr_0_1(status, str1, str2) {
            if (status === 0) {
                return str1 || ''
            }
            if (status === 1) {
                return str2 || ''
            }
        },
        // 格式化在线状态
        fmtOnlineStatus(status) {
            return funFmtOnlineStatus(status);
        },
    },
    watch: {
        modelData(newVal) {
            // console.log(newVal);
        }
    }
};
</script>
<style lang='less' scoped>
    .meter-detail-box{
        text-align: left;
        .meter-title{
            color: #333;
            font-weight: 400;
            font-size: 16px;
            line-height: 30px;
            margin: 15px 0;
            position: relative;
            padding-left: 15px;
            background-color: #e8e8e8;
            &:first-child{
                margin-top: 0;
            }
            &:before{
                content: "";
                position: absolute;
                left: 0;
                bottom: 0;
                height: 30px;
                width: 4px;
                background-color: @primary-color;
            }
        }
    }
</style>